export const handleTouchEnd = (e, touchStartX, setIsSwiped) => {
  if (e && e.changedTouches && e.changedTouches[0]) {
    const deltaX = e.changedTouches[0].clientX - touchStartX.current;
    setIsSwiped(deltaX < -50);
  }
};
